import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/SummaryPopup";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const SummaryPopupMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="SummaryPopup">
      <MobileNotice page="SummaryPopup" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default SummaryPopupMobile;